import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { UiTooltipComponent } from '@uigy/shared/components/tooltip/ui-tooltip/ui-tooltip.component';
import { take } from 'rxjs/operators';
import { LanguageService } from '@uigy/shared/services/language.service';
import { RiskScoreService } from '@uigy/shared/components/risk-score/services/risk-score.service';
import { AssetCategory } from '@uigy/generated/graphql';
import {
  IconNumberTextWidgetSize,
  IconNumberTextWidgetVariant
} from '@uigy/shared/components/ui-data-widgets/ui-icon-number-text-widget/interfaces';
import {
  IconNumberTextWidgetComponent
} from '@uigy/shared/components/ui-data-widgets/ui-icon-number-text-widget/icon-number-text-widget.component';
import { RiskModel, RiskService } from '@uigy/shared/services/risk.service';

@Component({
    selector: 'app-ui-risk-score-tooltip',
    imports: [
        IconNumberTextWidgetComponent
    ],
    templateUrl: './ui-risk-score-tooltip.component.html',
    styleUrl: './ui-risk-score-tooltip.component.scss'
})
export class UiRiskScoreTooltipComponent extends UiTooltipComponent implements OnInit {
  private languageService = inject(LanguageService);
  private riskScoreService = inject(RiskScoreService);
  private cdr = inject(ChangeDetectorRef);
  private riskService = inject(RiskService);

  public networkAssetsRiskScore?: number;
  public iotRiskScore?: number;
  public controllersRiskScore?: number;
  public networkAssetsRiskScoreVariant?: IconNumberTextWidgetVariant;
  public iotRiskScoreVariant?: IconNumberTextWidgetVariant;
  public controllersRiskScoreVariant?: IconNumberTextWidgetVariant;
  public riskTexts = this.languageService.texts.general.risk.widget;
  protected readonly iconNumberTextItemSize = IconNumberTextWidgetSize;
  protected readonly IconNumberTextWidgetVariant = IconNumberTextWidgetVariant;

  ngOnInit(): void {
    this.riskScoreService.getAssetsRiskByCategory().pipe(take(1)).subscribe(riskAssetsByCategory => {
      riskAssetsByCategory.forEach(item => {
        const riskScore = Math.floor(item.risk);
        const riskModel: RiskModel = this.riskService.getRiskModel(riskScore);

        switch (item.category) {
          case AssetCategory.NetworkAssetsCategory:
            this.networkAssetsRiskScore = riskScore;
            this.networkAssetsRiskScoreVariant = riskModel.riskWidgetVariant;
            break;
          case AssetCategory.IotCategory:
            this.iotRiskScore = riskScore;
            this.iotRiskScoreVariant = riskModel.riskWidgetVariant;
            break;
          case AssetCategory.ControllersCategory:
            this.controllersRiskScore = riskScore;
            this.controllersRiskScoreVariant = riskModel.riskWidgetVariant;
            break;
        }
      });
      this.cdr.markForCheck();
    });
  }
}
